// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__Sahie","description":"styles_description__1go_3","buttonGroup":"styles_buttonGroup__2HHc9","rowWrapper":"styles_rowWrapper__2TNWn"};